// extracted by mini-css-extract-plugin
module.exports = {"sidebarLink":"SubMenu_sidebarLink__SF3X3","sidebarLink2":"SubMenu_sidebarLink2__9PH1P"};